// Bu dosya, kargo işlemleriyle ilgili yardımcı fonksiyonları içerir.

/**
 * Kargo firmasının slug'ına ve takip numarasına göre
 * doğrudan takip sayfasına yönlendiren bir URL oluşturur.
 * 
 * @param {string} companySlug - Kargo firmasının slug'ı (örn: "aras", "yurtici").
 * @param {string} trackingNumber - Kargo takip numarası.
 * @returns {string} Oluşturulan tam takip URL'si.
 */
export const getTrackingUrl = (companySlug, trackingNumber) => {
    if (!trackingNumber) {
        return '#'; // Takip numarası yoksa link boş olsun
    }
    if (!companySlug) {
        // Slug yoksa genel bir Google araması linki döndür
        return `https://www.google.com/search?q=${encodeURIComponent(trackingNumber)}`;
    }

    const slug = companySlug.toLowerCase();

    switch (slug) {
        case 'aras':
            return `https://kargotakip.araskargo.com.tr/mainpage.aspx?code=${trackingNumber}`;
        case 'yurtici':
            return `https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code=${trackingNumber}`;
        case 'mng':
            return `https://www.mngkargo.com.tr/gonderitakip/${trackingNumber}`;
        case 'surat':
            return `https://suratkargo.com.tr/KargoTakip/?kargotakipno=${trackingNumber}`;
        case 'ptt':
            return `https://gonderitakip.ptt.gov.tr/Track/Verify?q=${trackingNumber}`;
        case 'ups':
            return `https://www.ups.com/track?loc=tr_TR&tracknum=${trackingNumber}`;
        case 'hepsijet':
            return `https://hepsijet.com/gonderi-takibi/${trackingNumber}`;
        case 'sendeo':
            return `https://kargotakip.sendeo.com.tr/kargo-takip/${trackingNumber}`;
        default:
            // Eğer slug listede yoksa, yine Google aramasına yönlendir
            return `https://www.google.com/search?q=${encodeURIComponent(companySlug + ' ' + trackingNumber)}`;
    }
};

/**
 * Verilen numaranın bir Kargonomi referans numarası olup olmadığını kontrol eder.
 * Genellikle çok uzun ve sayısaldır.
 * @param {string} trackingNumber 
 * @returns {boolean}
 */
export const isKargonomiReference = (trackingNumber) => {
    if (!trackingNumber) return false;
    // Kargonomi referans numaraları genellikle 15 haneden uzun ve sadece sayısaldır.
    // Gerçek takip numaraları genellikle daha kısadır.
    return /^\d{15,}$/.test(trackingNumber) || trackingNumber.startsWith('KARGO-');
};
